export default function pick(object, keysArray) {
  return Object.keys(object)
    .filter((key) => keysArray.indexOf(key) >= 0)
    .reduce((result, key) => {
      result[key] = object[key];
      return result;
    }, {});
}
